import { render } from "./ui-toggle-switcher.vue?vue&type=template&id=2766ca7a&scoped=true&ts=true"
import script from "./ui-toggle-switcher.vue?vue&type=script&lang=ts"
export * from "./ui-toggle-switcher.vue?vue&type=script&lang=ts"

import "./ui-toggle-switcher.vue?vue&type=style&index=0&id=2766ca7a&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2766ca7a"]])

export default __exports__